import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import { TranslateService } from '@ngx-translate/core';
import { CKEditor4 } from 'ckeditor4-angular';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Console } from 'console';
import { WordcountService } from '../../../../wordcount.service';

declare var decimalInput: any;

@Component({
  selector: 'app-upload',
  templateUrl: './upload.html',
  styleUrls: ['./upload.scss']
})

export class UploadQs implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public jsonFile: any;
  public filename: any;
  public uploadedfilename: any = "";
  public previewSrc: any = "";
  public previewSrcExtension = "";
  public attachment = false;
  public attachmentExt = "";
  public questionId = 0;

  private loadAnswersSubscription: Subscription;

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService,
    public sanitizer: DomSanitizer,
    private http: HttpClient,
    public wordCount: WordcountService
  ) {
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if (exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== "") {
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else {
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }
    
    this.loadAnswersSubscription = this.dataSvc.getLoadUploadAnswersEvent().subscribe(() => {
      this.loadAnswers();
    });
  }
  
  resetVariables(){
    
    this.previewSrc = "";
    this.previewSrcExtension = "";
    this.attachment = false;
    this.attachmentExt = "";
  }
  ngOnInit(): void {
    this.loadAnswers();
  }

  loadAnswers() {
    this.resetVariables();
    if (this.dataSvc.currentQuestion().Question.QuestionType !== 1032) return;

    (<HTMLInputElement>document.getElementById('fuUploadQ')).value = "";

    var url = this.dataSvc.currentQuestion().Result.Selection;
    if(url !== "" && url !== null && url !== undefined){
      this.attachment = true;
      this.previewSrc = url;

      var fileurlstr = localStorage.getItem("Upload_" + this.dataSvc.currentExam().Session.SessionId + "_" + this.dataSvc.currentQuestion().Question.Question.QuestionID);
      if(fileurlstr !== null && fileurlstr !== undefined && fileurlstr !== "")
        this.uploadedfilename = fileurlstr;

      this.previewSrcExtension = "./assets/ext/pdf.png";
      this.attachmentExt = "pdf";
      document.querySelector("#previewAttachment").setAttribute('href', this.previewSrc);
      document.querySelector("#previewImg").setAttribute('src', this.previewSrcExtension);
    }
    else{
      this.attachment = false;
      this.previewSrc = "";
      this.previewSrcExtension = "";
      document.querySelector("#previewAttachment").setAttribute('href', this.previewSrc);
      document.querySelector("#previewImg").setAttribute('src', this.previewSrcExtension);
    }

    clearInterval();
    
    if (this.attachment)
        setTimeout(() => this.updatePreviewSrc(), 200);
    
  }

  //LOAD FILE FROM DEVICE AND ATTEMPT TO READ JSON AND FILENAME
  loadFileFromDevice(event) {
    if(this.dataSvc.previewMode)
      return;

    
    const file = event.target.files[0];
    if(file !== null && file !== undefined){
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
          this.jsonFile = reader.result.toString();
          this.filename = file.name;
          localStorage.setItem("Upload_" + this.dataSvc.currentExam().Session.SessionId + "_" + this.dataSvc.currentQuestion().Question.Question.QuestionID, this.filename);
          this.uploadedfilename = this.filename;
          this.attachmentExt = this.filename.split('.').pop().toLowerCase()

          this.uploadAttachment();
      }
      reader.onerror = (error) => {
      //handle errors
      alert("Sorry file could not be uploaded. Please try again");
      };    
    }    
  }
  
  uploadAttachment() {
    if(this.dataSvc.previewMode)
      return;
      
    if (this.jsonFile !== null && this.jsonFile !== undefined && this.jsonFile !== "") {
      this.attachment = true;
      this.dataSvc.submitAttachment(this.dataSvc.currentQuestion().Question.Question.QuestionID, this.attachmentExt, this.jsonFile);
      this.updatePreviewSrc();
    }
    else{
      this.dataSvc.currentQuestion().Result.Selection = "";
      this.attachment = false;
      this.previewSrc = "";
      document.querySelector("#previewAttachment").setAttribute('href', this.previewSrc);
    document.querySelector("#previewImg").setAttribute('src', "");
    }
  }

  updatePreviewSrc() {
    this.previewSrc = this.dataSvc.blobUrl + "/" + this.dataSvc.assessBlobContainer + "/SessionFiles/Exam/" + this.dataSvc.currentExam().Session.SessionId
      + "/" + this.dataSvc.currentQuestion().Question.Question.QuestionID + "/attachment." + this.attachmentExt;
    this.previewSrcExtension = "./assets/ext/" + this.getPreviewExtension() + ".png";

    document.querySelector("#previewAttachment").setAttribute('href', this.previewSrc);
    document.querySelector("#previewImg").setAttribute('src', this.previewSrcExtension);
    this.dataSvc.currentQuestion().Result.Selection = this.previewSrc;
  }

  getPreviewExtension() {
    var fileExtension = this.attachmentExt;
    var extension = "";
    switch (fileExtension) {
      case "doc":
      case "docx":
        extension = "doc";
        break;
      case "xls":
      case "xlsx":
        extension = "xls";
        break;
      case "pdf":
        extension = "pdf";
        break;
      case "jpg":
      case "jpeg":
        extension = "jpg";
        break;
      case "mp3":
        extension = "mp3";
        break;
      case "gif":
        extension = "gif";
        break;
      case "zip":
        extension = "zip";
        break;
      case "txt":
        extension = "txt";
        break;
      default:
        extension = "file";
        break;
    }

    return extension;
  }

  openAttachment() {
    window.open(this.previewSrc);
  }

}
